const PAY_URL_PROTOCOL = /^https?:\/\//;

export function formatInvoicePayUrlDisplay(payUrl: string): string {
    return payUrl.replace(PAY_URL_PROTOCOL, "");
}
